
























import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import SegmentControls from '@/components/SegmentControls.vue';
import Icon from '@/components/Icon.vue';
import defaultRecordList from '@/constants/defaultRecordList';

@Component({
  components: {SegmentControls, Icon}
})
export default class TagsManage extends Vue {
  manageType = defaultRecordList.type;


  created() {
    this.$store.commit('initTag');
  }

  get tagList() {
    return this.$store.state.tagList as myTag[];
  }

  currentTagList() {
    return this.tagList.filter(item => item.type === this.manageType);
  }

  onTypeChanged(value: string) {
    this.manageType = value;
  }

  jumpToUpdateTag(icon: myTag) {
    const tagId = icon.id;
    this.$router.push({path: `/tagsmanage/tagedit/${tagId}`});
  }

  addTag() {
    this.$router.push({path: `/tagsmanage/${this.manageType}/tagAdd`});
  }
}
